import { TypographyPrinciples, TypographyHeadingTable, TypographyBodyTable, TypographyMetricTable, TypographyCodeTable } from '@af/design-system-docs-ui';
import Link from '@atlaskit/link';
import SectionMessage from '@atlaskit/section-message';
import { Stack, Text } from '@atlaskit/primitives';
import { AtlassianLogoCard, AttributionCards, PropertyCards, AppCards } from "../../../../src/pages/foundations/logos/_logo-asset-cards.partial";
import tileRadiusDo from "../../../../src/pages/foundations/logos/_assets/tile-radius-do.png";
import tileRadiusDont from "../../../../src/pages/foundations/logos/_assets/tile-radius-dont.png";
import containersDo from "../../../../src/pages/foundations/logos/_assets/containers-do.png";
import containersDont from "../../../../src/pages/foundations/logos/_assets/containers-dont.png";
import colorDont from "../../../../src/pages/foundations/logos/_assets/color-dont.png";
import shadowDont from "../../../../src/pages/foundations/logos/_assets/shadow-dont.png";
import legibilityDont from "../../../../src/pages/foundations/logos/_assets/legibility-dont.png";
import outlineDont from "../../../../src/pages/foundations/logos/_assets/outline-dont.png";
import * as React from 'react';
export default {
  TypographyPrinciples,
  TypographyHeadingTable,
  TypographyBodyTable,
  TypographyMetricTable,
  TypographyCodeTable,
  Link,
  SectionMessage,
  Stack,
  Text,
  AtlassianLogoCard,
  AttributionCards,
  PropertyCards,
  AppCards,
  tileRadiusDo,
  tileRadiusDont,
  containersDo,
  containersDont,
  colorDont,
  shadowDont,
  legibilityDont,
  outlineDont,
  React
};